import { useCallback } from 'react'

import { useDispatch, useSelector } from 'react-redux'

import { boxSummaryVisibilityChange } from 'actions/boxSummary'
import { useBasket } from 'routes/Menu/domains/basket'
import { getBasketRecipesCount } from 'selectors/basket'

import { setCuratedBox } from '../../actions/menuRecipeDetails'
import { trackAddCuratedBox } from '../trackCuratedBox'

export const useAddCuratedBoxRecipes = (hasSeenWarningModal: boolean) => {
  const { addRecipe, numPortions, menuId } = useBasket()
  const basketRecipesCount = useSelector(getBasketRecipesCount)
  const dispatch = useDispatch()

  const addCuratedBoxRecipes = useCallback(
    (selectedCuratedBox) => {
      const { curatedBoxRecipes, curatedBoxCollectionId, curatedBoxName, carouselIndex } =
        selectedCuratedBox
      dispatch(setCuratedBox(curatedBoxCollectionId, curatedBoxName))
      curatedBoxRecipes.forEach((recipe: string) => {
        addRecipe(recipe, undefined, undefined, undefined, undefined, true)
      })
      dispatch(boxSummaryVisibilityChange(true, () => {}))
      dispatch(
        trackAddCuratedBox(
          numPortions,
          curatedBoxName,
          carouselIndex,
          curatedBoxRecipes,
          curatedBoxCollectionId,
          menuId,
          hasSeenWarningModal,
          basketRecipesCount,
        ),
      )
    },
    [addRecipe, basketRecipesCount, dispatch, hasSeenWarningModal, menuId, numPortions],
  )

  return { addCuratedBoxRecipes }
}
